import { useState } from "react";
import "../crm.css";

const LOAN_TYPES = [
  "Fix & Flip",
  "Ground Up Construction",
  "Rental Property",
  "Bridge Loan",
  "Term Loan",
  "DSCR Loan",
  "Not sure yet",
];

export default function Prequalify() {
  const params = new URLSearchParams(window.location.search);
  const leadId = params.get("lead");
  const [consent, setConsent] = useState(false);

  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    projectType: "",
    hasProperty: "",
    creditScore: "",
    hasLlc: "",
    timeline: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [outcome, setOutcome] = useState(null);

  const set = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await fetch("/api/prequal", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({leadId, consent, ...form }),
      });
    } catch (err) {
      console.error("Prequal save failed:", err);
    }
    setOutcome("done");
    setSubmitting(false);
  };

  if (outcome) {
    return (
      <div className="page" style={{ maxWidth: 520, margin: "60px auto" }}>
        <div className="card">
          <div className="card-body" style={{ textAlign: "center", padding: 40 }}>
            <div className="placeholder-icon blue" style={{ margin: "0 auto 16px" }}>
              🎉
            </div>
            <div className="page-title" style={{ marginBottom: 8 }}>You are Pre-Qualified!</div>
            <div className="page-subtitle" style={{ marginBottom: 24 }}>
              Complete your full qualification below to view your loan options.
            </div>
            <button
              className="btn btn-primary"
              style={{ fontSize: 15, padding: "12px 28px" }}
              onClick={() => { window.location.href = "https://loans.propertunitycapital.com/soft-credit-pull/"; }}
            >
              Start Qualification
            </button>
            <p style={{ marginTop: 16, fontSize: 12, color: "#94a3b8" }}>
              Takes less than 2 minutes - no impact to your credit.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page" style={{ maxWidth: 520, margin: "60px auto" }}>
      <div className="card">
        <div className="card-header">
          <div>
            <div className="card-title">Quick Pre-Qualification</div>
            <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>Takes about 2 minutes</div>
          </div>
          <span className="badge badge-blue">Step {step} of 5</span>
        </div>

        <div style={{ height: 4, background: "#f1f5f9" }}>
          <div style={{ height: "100%", width: `${(step / 5) * 100}%`, background: "#2563eb", transition: "width 0.3s" }} />
        </div>

        <div className="card-body">

          {step === 1 && (
            <div>
              <p className="form-label" style={{ marginBottom: 12 }}>What type of loan are you looking for?</p>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                {LOAN_TYPES.map(t => (
                  <button
                    key={t}
                    className={form.projectType === t ? "btn btn-primary" : "btn btn-secondary"}
                    onClick={() => { set("projectType", t); setStep(2); }}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>
          )}

          {step === 2 && (
            <div>
              <p className="form-label" style={{ marginBottom: 12 }}>Do you have a specific property in mind?</p>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <button className={form.hasProperty === "yes" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("hasProperty", "yes"); setStep(3); }}>Yes, I have a property identified</button>
                <button className={form.hasProperty === "looking" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("hasProperty", "looking"); setStep(3); }}>Still looking</button>
                <button className={form.hasProperty === "no" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("hasProperty", "no"); setStep(3); }}>No property yet</button>
              </div>
            </div>
          )}

          {step === 3 && (
            <div>
              <p className="form-label" style={{ marginBottom: 12 }}>What is your approximate credit score?</p>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <button className={form.creditScore === 760 ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("creditScore", 760); setStep(4); }}>750 or above</button>
                <button className={form.creditScore === 720 ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("creditScore", 720); setStep(4); }}>700 to 749</button>
                <button className={form.creditScore === 670 ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("creditScore", 670); setStep(4); }}>650 to 699</button>
                <button className={form.creditScore === 600 ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("creditScore", 600); setStep(4); }}>Below 650</button>
              </div>
            </div>
          )}

          {step === 4 && (
            <div>
              <p className="form-label" style={{ marginBottom: 12 }}>Do you have an LLC?</p>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <button className={form.hasLlc === "yes" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("hasLlc", "yes"); setStep(5); }}>Yes, I have an active LLC</button>
                <button className={form.hasLlc === "willing" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("hasLlc", "willing"); setStep(5); }}>No, but I am willing to create one</button>
                <button className={form.hasLlc === "no" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => { set("hasLlc", "no"); setStep(5); }}>No, and I prefer not to</button>
              </div>
            </div>
          )}

         {step === 5 && (
            <div>
              <p className="form-label" style={{ marginBottom: 12 }}>
                What is your timeline to get funded?
              </p>

              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <button
                  className={form.timeline === "asap" ? "btn btn-primary" : "btn btn-secondary"}
                  onClick={() => set("timeline", "asap")}
                >
                  ASAP - ready to move now
                </button>

                <button
                  className={form.timeline === "30days" ? "btn btn-primary" : "btn btn-secondary"}
                  onClick={() => set("timeline", "30days")}
                >
                  Within 30 days
                </button>

                <button
                  className={form.timeline === "60days" ? "btn btn-primary" : "btn btn-secondary"}
                  onClick={() => set("timeline", "60days")}
                >
                  1 to 3 months
                </button>

                <button
                  className={form.timeline === "exploring" ? "btn btn-primary" : "btn btn-secondary"}
                  onClick={() => set("timeline", "exploring")}
                >
                  Just exploring options
                </button>
              </div>

              {/* ✅ SINGLE OPT-IN BLOCK */}
              <div
                style={{
                  marginTop: 16,
                  padding: 12,
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  background: "#f8fafc",
                }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 10,
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    style={{ marginTop: 4 }}
                  />
                  <span
                    style={{
                      fontSize: 12,
                      color: "#475569",
                      lineHeight: 1.4,
                    }}
                  >
                    I agree to receive SMS messages from{" "}
                    <strong>Propertunity Capital</strong> about my real estate financing
                    inquiry, including prequalification, document requests, and loan
                    updates. Message frequency varies. Message & data rates may apply.
                    Reply STOP to opt out, HELP for help.
                  </span>
                </label>

                <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6 }}>
                  View our{" "}
                  <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                  </a>{" "}.
                </div>
              </div>

              {/* ✅ SUBMIT BUTTON */}
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={!form.timeline || !consent || submitting}
                style={{
                  width: "100%",
                  marginTop: 20,
                  justifyContent: "center",
                  opacity: !form.timeline || !consent || submitting ? 0.6 : 1,
                  cursor: !form.timeline || !consent || submitting ? "not-allowed" : "pointer",
                }}
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}